import React from 'react'
import {useNavigate} from 'react-router-dom';

function NavbarComponent() {
  const navigate = useNavigate();
  const handleSignup = () =>{
    navigate("/signup");
  }

  const handleLogin = () =>{
    navigate("/login");
  }
  return (
    <div id='navbar-container'>
        <nav id='navbar'>
            <h2 id='nav-heading'>Penpal.ai</h2>
            <div id = "nav-button-group">
            <button className='form-submit-button nav-cta' onClick={handleSignup}>Signup</button>
            <button className='form-submit-button nav-cta' onClick = {handleLogin}>Login</button>
            </div>
        </nav>
    </div>
  )
}

export default NavbarComponent